import React, { useMemo } from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { MisVisitasCreationContent } from './components/MisVisitasCreationContent';
import { VisitaProvider } from '../../context/VisitaContext';
import moment from 'moment';
import { useLocation } from 'react-router-dom';

export default function MisVisitasCreation() {
    const location = useLocation();
    const { isNew } = location.state;
    const initialValue = useMemo(() => ({
        fechaVisita: moment().format('yyyy-MM-DD HH:mm:ss'),
        //Enfermería
        idTeleEnfermeriaAE: 0,
        idTeleEnfermeriaCP: 0,
        idTeleEnfermeriaAP: 0,
        idPresencialAP: 0,
        idBombaInfusionTelemedicina: 0,
        idCumplimientoIndicacion: 0,
        idParametrosControlClinico: 0,
        idInsumoCapacitacion: 0,
        idPresencialAE: 0,
        //Médico
        idVisitaDatoClinico: 0,
        idVisitaEnteral: 0,
        idVisitaParenteral: 0,
        idVisitaNpid: 0,
        idVisitaOral: 0,
        idVisitaKeto: 0,
        idVisitaCeao: 0,
        idVisitaCeae: 0,
        idVisitaHe: 0,
        idVisitaDisfagia: 0,
    }), []);

    return (
        <VisitaProvider initialValue={initialValue}>
            <MainContent
                component={<MisVisitasCreationContent />}
                noBackground
                tableMaxWidth
                customSectionTitle={`${isNew ? 'Nueva' : 'Editar'} visita`}
            />
        </VisitaProvider>
    );
};